import React from 'react'

import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Box,
  Divider,
  Paper,
  Tooltip,
  IconButton,
  Typography,
} from '@material-ui/core'

import { Delete as DeleteIcon } from '@material-ui/icons'

import { DotStatus } from 'components'
import { Permitted } from 'components/Permissions'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import DialogInactivateInvoiceItem from './../DialogInactivateInvoiceItem'
import DialogCancelByInvoiceItem from './../DialogCancelByInvoiceItem'
import helpers from 'helpers'

const InvoiceItems = ({ invoice, setReload = () => {} }) => {
  const [invoiceItem, setInvoiceItem] = React.useState()
  const [
    dialogInactivateInvoiceItem,
    setDialogInactivateInvoiceItem,
  ] = React.useState(false)
  const [
    dialogCancelByInvoiceItem,
    setDialogCancelByInvoiceItem,
  ] = React.useState(false)

  const handleClick = item => {
    setInvoiceItem(item)
    const totalPrice = invoice.invoiceItems
      .filter(item => item.active)
      .reduce((total, a) => total + parseFloat(a.price), 0)
    if (totalPrice - item.price <= 0) {
      return setDialogCancelByInvoiceItem(true)
    }
    setDialogInactivateInvoiceItem(true)
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Itens da Fatura</Typography>
      </Box>
      <Divider />
      <PerfectScrollbar>
        <Table noWrap>
          <TableHead>
            <TableRow>
              <TableCell>Descrição</TableCell>
              <TableCell align="center">Período</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell align="right">Valor</TableCell>
              <TableCell align="center">Status</TableCell>
              <Permitted tag="destroy_invoice_item">
                <TableCell></TableCell>
              </Permitted>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoice.invoiceItems.map(item => (
              <TableRow hover key={item.id}>
                <TableCell>{item.description}</TableCell>
                <TableCell align="center">
                  {helpers.invoiceItems.period(item)}
                </TableCell>
                <TableCell>{item.resourceLabel}</TableCell>
                <TableCell align="right">
                  {helpers.currency(parseFloat(item.price))}
                </TableCell>
                <TableCell align="center">
                  <DotStatus
                    statusName={helpers.invoiceItems.status(
                      item.active ? 'active' : 'inactive',
                    )}
                    statusTag={item.active ? 'active' : 'inactive'}
                    entity="invoiceItem"
                  />
                </TableCell>
                <Permitted tag="destroy_invoice_item">
                  <TableCell align="right" width="10%">
                    {item.canInactivate ? (
                      <Tooltip title="Inativar Item da fatura">
                        <IconButton
                          aria-label="Inativar"
                          onClick={() => {
                            handleClick(item)
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <IconButton aria-label="Inativar" disabled={true}>
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </Permitted>
              </TableRow>
            ))}
            <TableRow>
              <TableCell rowSpan={3} />
              <TableCell rowSpan={3} />
              <TableCell colSpan={4} align="right">
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  flexDirection="column"
                >
                  <Typography variant="h4" component="strong">
                    {`Valor total: ${helpers.currency(invoice.amountDue)}`}
                  </Typography>
                  {helpers.invoices.statusVerification.isPartiallyPaid(
                    invoice.status,
                  ) && (
                    <Typography variant="h5" component="strong">
                      {`Valor pago: ${helpers.currency(invoice.paidValue)}`}
                    </Typography>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </PerfectScrollbar>

      {invoiceItem && (
        <DialogInactivateInvoiceItem
          open={dialogInactivateInvoiceItem}
          setOpen={setDialogInactivateInvoiceItem}
          onEvent={setReload}
          invoiceItemId={invoiceItem.id}
        />
      )}
      {invoiceItem && (
        <DialogCancelByInvoiceItem
          open={dialogCancelByInvoiceItem}
          setOpen={setDialogCancelByInvoiceItem}
          onEvent={setReload}
          invoiceItemId={invoiceItem.id}
        />
      )}
    </Paper>
  )
}

export default InvoiceItems
